// extracted by mini-css-extract-plugin
module.exports = {"errorBoundaryCard":"ErrorBoundary_errorBoundaryCard__2DZLE"};